import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  Container,
  Center,
  Button,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  Input,
  Heading,
  VStack,
  RadioGroup,
  Radio,
  Select,
  HStack,
  Grid,
  GridItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";
import { brandRegister, brandLogin } from "../actions/auth";
import { useNavigate } from "react-router-dom";
import PrivacyPolicy from "../components/privacyPolicy";

function LoginBrand() {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("jwtToken")) {
      return navigate(`/brandCampaigns`);
    }
  });
  const lightGray = useColorModeValue("gray.600", "gray.100");

  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  };
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPass, setLoginPass] = useState("");
  const [loginEmailErr, setLoginEmailErr] = useState();
  const [loginPassErr, setLoginPassErr] = useState();
  const [loginErr, setLoginErr] = useState("");

  const [registerName, setRegisterName] = useState("");
  const [registerOccupation, setRegisterOccupation] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerPhone, setRegisterPhone] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerOrganization, setRegisterOrganization] = useState("");
  const [registerAddress, setRegisterAddress] = useState("");
  const [registerErrors, setRegisterErrors] = useState([]);

  const submitRegistration = async () => {
    setRegisterErrors([]);
    let errors = [];
    if (!registerName) {
      errors.push("Name is a required field");
    }
    if (!registerOccupation) {
      errors.push("Occupation is a required field");
    }
    if (!registerEmail) {
      errors.push("Email is a required field");
    }
    if (!registerPassword) {
      errors.push("Password is a required field");
    }
    if (!registerOrganization) {
      errors.push("Organization is a required field");
    }
    if (!registerAddress) {
      errors.push("Address is a required field");
    }
    if (errors.length) {
      setRegisterErrors([...errors]);
      return;
    }

    try {
      const registrationAttempt = await brandRegister({
        name: registerName,
        occupation: registerOccupation,
        email: registerEmail,
        password: registerPassword,
        organization: registerOrganization,
        address: registerAddress,
      });

      if (registrationAttempt) {
        const loginAttempt = await brandLogin(registerEmail, registerPassword);
        localStorage.setItem("jwtToken", loginAttempt.token);
        return navigate(`/brand/${registerOrganization}?setUp=true`);
      }
    } catch (err) {
      console.log(err);
      let errors = [];
      Object.keys(err).map((e) => {
        errors.push(err[e]);
      });
      setRegisterErrors(errors);
    }
  };

  const submitLogin = async () => {
    setLoginEmailErr("");
    setLoginPassErr("");
    let errors = false;
    if (!loginEmail) {
      setLoginEmailErr("Email is required to login");
      errors = true;
    } else if (!loginEmail.includes("@") || !loginEmail.includes(".")) {
      setLoginEmailErr("Email address is invalid");
      errors = true;
    }
    if (!loginPass) {
      setLoginPassErr("Password is required to login");
      errors = true;
    }

    if (errors) {
      return;
    }

    try {
      const loginAttempt = await brandLogin(loginEmail, loginPass);

      localStorage.setItem("jwtToken", loginAttempt.token);
      return navigate("/brandCampaigns");
    } catch (err) {
      console.log(err);
      setLoginErr(err);
    }
  };

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav page={"loginBrand"} />

      <GridItem pl="2" area={"main"}>
        <VStack>
          <Box mt="8">
            <Heading
              color={useColorModeValue("gray.1000", "gray.100")}
              fontSize="2xl"
            >
              Welcome to Hubit for <Text as="i">Production companies</Text>!
            </Heading>
          </Box>

          <Card
            mx="5"
            my="5"
            p="45px"
            minW="2xl"
            bg={useColorModeValue("gray.100", "gray.900")}
            align="top"
          >
            <HStack>
              <Box width="100%" px="6" borderRight="1px" borderColor="gray.200">
                <form>
                  <Center>
                    <Heading fontSize="lg">Create an Account</Heading>
                  </Center>

                  <Container mt="6">
                    <HStack>
                      <Box width="100%">
                        <Input
                          variant="flushed"
                          type="text"
                          value={registerName}
                          onChange={(e) => setRegisterName(e.target.value)}
                          placeholder="Name"
                        />
                      </Box>

                      <Box width="100%">
                        <Input
                          variant="flushed"
                          type="text"
                          value={registerOccupation}
                          onChange={(e) =>
                            setRegisterOccupation(e.target.value)
                          }
                          placeholder="Occupation"
                        />
                      </Box>
                    </HStack>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="password"
                        value={registerPassword}
                        onChange={(e) => setRegisterPassword(e.target.value)}
                        placeholder="Password"
                      />
                    </Box>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="text"
                        value={registerEmail}
                        onChange={(e) => setRegisterEmail(e.target.value)}
                        placeholder="Email address"
                      />
                    </Box>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="text"
                        value={registerOrganization}
                        onChange={(e) =>
                          setRegisterOrganization(e.target.value)
                        }
                        placeholder="Organization"
                      />
                    </Box>

                    <Box width="100%" my="4">
                      <Input
                        variant="flushed"
                        type="text"
                        value={registerAddress}
                        onChange={(e) => setRegisterAddress(e.target.value)}
                        placeholder="Address"
                      />
                    </Box>
                  </Container>

                  <Box width="100%" mt="6">
                    <Center>
                      <Button
                        isDisabled={
                          !registerName ||
                          !registerOccupation ||
                          !registerPassword ||
                          !registerEmail ||
                          !registerOrganization ||
                          !registerAddress
                        }
                        colorScheme="green"
                        type="submit"
                        width="100%"
                        onClick={async (e) => {
                          e.preventDefault();
                          await submitRegistration();
                        }}
                      >
                        Sign Up
                      </Button>
                    </Center>
                    <Center>
                      <Box>
                        <Text fontSize="xs" mt="2">
                          By signing up, you agree to our{" "}
                          <Link onClick={() => setIsOpen(true)}>
                            <Text as="u" color="teal">
                              Privacy Policy
                            </Text>
                          </Link>
                        </Text>
                      </Box>
                    </Center>
                    {registerErrors.length > 0 &&
                      registerErrors.map((err) => {
                        return (
                          <Center>
                            <Box>
                              <Text color="red.500">{err}</Text>
                            </Box>
                          </Center>
                        );
                      })}
                  </Box>
                </form>
              </Box>

              <Box align="top" width="100%">
                <form>
                  <Center>
                    <Text fontSize="lg">
                      Already have a Production Company Account? <Text as="b">Sign In:</Text>
                    </Text>
                  </Center>

                  <Box width="100%" my="4" px="5">
                    <FormControl isInvalid={loginEmailErr}>
                      <Input
                        variant="flushed"
                        type="text"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                        placeholder="Email"
                      />
                      <FormErrorMessage>{loginEmailErr}</FormErrorMessage>
                    </FormControl>
                  </Box>

                  <Box width="100%" my="2" px="5">
                    <FormControl isInvalid={loginPassErr}>
                      <Input
                        variant="flushed"
                        type="password"
                        value={loginPass}
                        onChange={(e) => setLoginPass(e.target.value)}
                        placeholder="Password"
                      />
                      <FormErrorMessage>{loginPassErr}</FormErrorMessage>
                    </FormControl>
                  </Box>

                  <Box width="100%" mt="6">
                    <Center>
                      <Button
                        type="submit"
                        onClick={async (e) => {
                          e.preventDefault();
                          await submitLogin();
                        }}
                        isDisabled={!loginEmail || !loginPass}
                        colorScheme="blue"
                      >
                        Sign In
                      </Button>
                    </Center>
                    {loginErr && (
                      <Center>
                        {Object.keys(loginErr).map((key) => {
                          return (
                            <Box>
                              <Text color="red.500">{loginErr[key]}</Text>
                            </Box>
                          );
                        })}
                      </Center>
                    )}
                  </Box>
                </form>
              </Box>
            </HStack>
          </Card>
          <Text color={lightGray} fontSize="sm">
            Not a production company?{" "}
            <Link to="/login">
              <Text color="teal" as="u">
                Click here
              </Text>
            </Link>{" "}
            to use the normal login/signup
          </Text>
        </VStack>
      </GridItem>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading fontSize="xl">Hubit Privacy Policy</Heading>
          </ModalHeader>
          <ModalCloseButton />
          <PrivacyPolicy />
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>

      {/*
      <GridItem area={'footer'}>
        <Box
          p="30px"
          width="100%"
          bg={useColorModeValue('gray.600', 'gray.600')}
          color={useColorModeValue('gray.100', 'gray.100')}
        >
          <Center>
            <Text>Copyright © {new Date().getFullYear()} Hubit</Text>
          </Center>
        </Box>
      </GridItem>
      */}
    </Grid>
  );
}

export default LoginBrand;
